import { BindingCreator } from '@dreryk/react-common';
import { TestId, TextInput } from '@dreryk/react-components';

import { referralToPsychiatricHospitalTranslationKeys } from '../../../../translations';

import { StyledGuardianLastName } from './GuardianSection.styled';
import { GuardianEnteredByUserFormBeanPart, GuardianFieldName } from './guardianSection.types';

type GuardianNameSectionProps<FIELD_NAME extends GuardianFieldName> = {
   readonly register: BindingCreator<GuardianEnteredByUserFormBeanPart>;
   readonly name: FIELD_NAME;
   readonly testId: TestId;
};

const NAME_MAX_LENGTH = 50;

export const GuardianNameSection = <FIELD_NAME extends GuardianFieldName>(
   props: GuardianNameSectionProps<FIELD_NAME>
): JSX.Element => {
   return (
      <>
         <TextInput
            testId={`${props.testId}FirstName`}
            controller={props.register(`${props.name}EnteredByUser.firstName`, {
               required: true,
               maxLength: NAME_MAX_LENGTH,
            })}
            label={referralToPsychiatricHospitalTranslationKeys.firstName}
         />
         <StyledGuardianLastName>
            <TextInput
               testId={`${props.testId}LastName`}
               controller={props.register(`${props.name}EnteredByUser.lastName`, {
                  required: true,
                  maxLength: NAME_MAX_LENGTH,
               })}
               label={referralToPsychiatricHospitalTranslationKeys.lastName}
            />
         </StyledGuardianLastName>
      </>
   );
};
